import script from "./IncomeCharts.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomeCharts.vue?vue&type=script&setup=true&lang=ts"

import "./IncomeCharts.vue?vue&type=style&index=0&id=04352d8c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04352d8c"]])

export default __exports__